<template>
    <div>
        <v-row class="d-flex justify-center">
            <v-col cols="12" lg="10" xl="9">
                <Datatable :headers="tableHeaders" :items="sizes" title="Sizes" :items-per-page="-1"
                           @click:row="emitClicked"
                           @click:edit="emitClicked"
                           @click:delete="emitClicked($event, true)"
                >
                    <template #top>
                        <Button v-if="$vuetify.breakpoint.mdAndUp" icon="mdi-plus" :color="ada.blue"
                                @click="emitClicked(null)"
                        >Size hinzufügen
                        </Button>
                    </template>
                </Datatable>
            </v-col>
        </v-row>
        <AddEditSizeDialog v-model="showDialog"></AddEditSizeDialog>
        <DeleteSizeDialog v-model="showDeleteDialog"></DeleteSizeDialog>
    </div>
</template>

<script>
import Datatable from "../../../components/Tables/Datatable";
import Button from "../../../components/buttons/Button";
import ada from "../../../scss/ada_colors.scss";
import AddEditSizeDialog from "../Dialogs/AddEditSizeDialog";
import DeleteSizeDialog from "../Dialogs/DeleteSizeDialog";

export default {
    name: "Settings_Size",
    components: {DeleteSizeDialog, AddEditSizeDialog, Button, Datatable},
    data: () => {
        return {
            tableHeaders: [
                {text: 'Bezeichnung', value: 'Name', width: '300px'},
                {text: 'Typ', value: 'Type'},
                {text: 'Erstellt am', value: 'Created', width: '250px'},
                {text: 'Aktion', value: 'action', width: '100px', sortable: false},
            ],
            showDialog: false,
            showDeleteDialog: false,
            ada
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.settings;
        },
        sizes() {
            let sizes = this.vuexState.sizes ? this.vuexState.sizes : [];
            sizes.forEach((item) => {
                item.action = ['edit', 'delete'];
            })
            return sizes;
        },
    },
    methods: {
        emitClicked(item, deleting = false) {
            this.$emit('click', item, deleting, this);
        },
    },
}
</script>

<style scoped>

</style>